module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"pagination":{"showing":"Mostrando","showing_of":"de","results":"resultados","preview":"Anterior","next":"Próxima"}},"en":{"pagination":{"showing":"Showing","showing_of":"of","results":"results","preview":"Preview","next":"Next"}}}')
  delete Component.options._Ctor
}
